import React from "react";
import { Grid, ListItemAvatar } from "e100-react-components";

import { SortTypeMyFleet } from "features/myFleet";
import { LocationStatusIcon } from "shared/components";
import { ACTIVE_STATUS } from "shared/constants/obu";

interface ObuStatusIconProps {
  sortType: SortTypeMyFleet;
}

export const ObuStatusIcon = ({ sortType }: ObuStatusIconProps) => {
  if (sortType === "byLocationStatusDesc") {
    return (
      <ListItemAvatar>
        <Grid container justify="space-evenly">
          <Grid item>
            <LocationStatusIcon status={ACTIVE_STATUS.MORE_10} />
          </Grid>
          <Grid item>
            <LocationStatusIcon status={ACTIVE_STATUS.FROM_4_TO_10_HOURS} />
          </Grid>
          <Grid item>
            <LocationStatusIcon status={ACTIVE_STATUS.FROM_0_TO_4_HOURS} />
          </Grid>
        </Grid>
      </ListItemAvatar>
    );
  }

  if (sortType === "byLocationStatusAsc") {
    return (
      <ListItemAvatar>
        <Grid container justify="space-evenly">
          <Grid item>
            <LocationStatusIcon status={ACTIVE_STATUS.FROM_0_TO_4_HOURS} />
          </Grid>
          <Grid item>
            <LocationStatusIcon status={ACTIVE_STATUS.FROM_4_TO_10_HOURS} />
          </Grid>
          <Grid item>
            <LocationStatusIcon status={ACTIVE_STATUS.MORE_10} />
          </Grid>
        </Grid>
      </ListItemAvatar>
    );
  }

  return null;
};
